import { useEffect, useMemo, useState } from 'react';
import apiAxios from 'helpers/apiAxios';
import { LOGISTIC_CONTAINER_TYPE } from 'app_config';

// Container types now live in App Settings (CRM → Logistic →
// CRM_LOGISTIC_CONTAINER_TYPES), served by Crm::Logistic::ContainerTypes.
// app_config's list is only the fallback while loading or if the call fails,
// so the field is never empty.
let cached = null;

export const resetContainerTypesCache = () => { cached = null; };

const loadContainerTypes = () => {
  if (!cached) {
    cached = apiAxios.get('/crm/settings/logistic_container_types', { skipErrorToast: true })
      .then(({ data }) => (Array.isArray(data) && data.length ? data : LOGISTIC_CONTAINER_TYPE))
      .catch(() => {
        cached = null; // let the next mount try again
        return LOGISTIC_CONTAINER_TYPE;
      });
  }
  return cached;
};

// `keep` are values already on the record(s): a type removed from App Settings
// must still show on a row that carries it, or the select would look blank and
// the next save would quietly drop it.
export const useContainerTypeOptions = (keep = []) => {
  const [types, setTypes] = useState(LOGISTIC_CONTAINER_TYPE);

  useEffect(() => {
    let active = true;
    loadContainerTypes().then(list => { if (active) setTypes(list); });
    return () => { active = false; };
  }, []);

  const keepKey = [].concat(keep).filter(Boolean).join('|');
  return useMemo(() => {
    const extra = keepKey ? keepKey.split('|').filter(value => !types.includes(value)) : [];
    return [...types, ...extra].map(value => ({ value, label: value }));
  }, [types, keepKey]);
};
